const SITE_ORIGIN = 'https://morningstudio.com.au'

function setMetaByName(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setMetaByProperty(property: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(
    `meta[property="${property}"]`,
  )
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

/**
 * Keeps `<link rel="canonical">`, the description meta, and OG/Twitter tags
 * in sync with the SPA route. `index.html` only ships defaults for `/`, so
 * every other route must call this or it inherits the homepage canonical.
 */
export function setPageMeta({
  path,
  title,
  description,
  noindex = false,
}: {
  path: string
  title: string
  description: string
  noindex?: boolean
}) {
  const url = `${SITE_ORIGIN}${path === '/' ? '/' : path}`

  document.title = title

  let canonical = document.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  )
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', url)

  setMetaByName('description', description)
  setMetaByName(
    'robots',
    noindex
      ? 'noindex, follow'
      : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
  )

  setMetaByProperty('og:title', title)
  setMetaByProperty('og:description', description)
  setMetaByProperty('og:url', url)
  setMetaByName('twitter:title', title)
  setMetaByName('twitter:description', description)
}
